import React, {Component} from "react";
import PropTypes from "prop-types";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import holdCursorPosition from "../../../helpers/formUtils";
import initialState from "../../../reducers/communications/initialState";
import {RequiredInput} from "Ncontracts.Common.UI";
import CharCountTextarea from "../../common/CharCountTextarea/CharCountTextarea";
import {
    handleNewCommunicationTextInputChange,
    TOGGLE_VOICE_CALL_CHECKBOX
} from "../../../actions/communications/newCommunicationAction";
import ImageCheckbox from "../../common/ImageCheckbox";
import isEmpty from "../../../helpers/isEmpty";

class NewCommunicationMessageForm extends Component {

    static propTypes = {
        message: PropTypes.string,
        handleTextInputChange: PropTypes.func,
        sendVoiceCalls: PropTypes.bool,
        title: PropTypes.string,
        toggleVoiceCallCheckbox: PropTypes.func
    };

    static defaultProps = {
        ...initialState
    };

    constructor(props, context) {
        super(props, context);

        this.state = {
            isMessageInitialized: !isEmpty(this.props.message),
            isTitleInitialized: !isEmpty(this.props.title)
        };
    }

    handleMessageChange = e => {
        this.setState({...this.state, isMessageInitialized: true});
        this.props.handleTextInputChange("message", e.target.value);
    };

    handleTitleChange = e => {
        holdCursorPosition(e);
        this.setState({...this.state, isTitleInitialized: true});
        this.props.handleTextInputChange("title", e.target.value);
    };

    render() {
        const {message, title, sendVoiceCalls, toggleVoiceCallCheckbox} = this.props;
        const isTitleValid = !isEmpty(title);
        const isMessageValid = !isEmpty(message);
        const voiceCheckbox = (
            <div className="checkbox-with-label" onClick={() => toggleVoiceCallCheckbox()}>
                <div className="checkbox"><ImageCheckbox isSelected={sendVoiceCalls}/></div>
                <div className="checkbox-label">Message to voice call</div>
            </div>
        );

        return (
            <div className="new-message-form">
                <div className="title-input">
                    <RequiredInput label={'Title'} shouldValidate={this.state.isTitleInitialized}
                                   isValid={isTitleValid} validationMessage="Please enter a title">
                        <input name="title"
                               className="input"
                               value={title}
                               maxLength={75}
                               onChange={e => this.handleTitleChange(e)}
                        />
                    </RequiredInput>
                </div>
                <div className="message-input">
                    <RequiredInput label={'Message'} shouldValidate={this.state.isMessageInitialized}
                                   isValid={isMessageValid} validationMessage="Please enter a message">
                        <CharCountTextarea
                            name="message"
                            className="input"
                            value={message}
                            rows={3}
                            maxLength={500}
                            leftFooterContent={voiceCheckbox}
                            onChange={e => this.handleMessageChange(e)}
                        />
                    </RequiredInput>
                </div>
            </div>);
    }
}

const mapStateToProps = state => ({
    message: state.newCommunication.message,
    sendVoiceCalls: state.newCommunication.sendVoiceCalls,
    title: state.newCommunication.title
});

const mapDispatchToProps = dispatch => ({
    handleTextInputChange: (name, value) => dispatch(handleNewCommunicationTextInputChange(name, value)),
    toggleVoiceCallCheckbox: () => dispatch({type: TOGGLE_VOICE_CALL_CHECKBOX})
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewCommunicationMessageForm));
